// library
import React, {useEffect, useRef, useState} from "react";
import {Box, Button, FormGroup, Stack,} from "@mui/material";
import {useFormik} from "formik";
// style
import {FormCheckBox, GridBlock, Headline, InputBox, InputHelperText, InputUpperLabel, StyledCheckBox,} from "./style";
import {StyledNewInput} from "../../../components/common/StyledInput";
import {loginSchema} from "../helper";
import {login} from "../../../store/auth/auth.action";
import {useAppDispatch, useTypedSelector} from "../../../store";


const LoginForm: React.FC = () => {
  const dispatch = useAppDispatch();

  const [isLimit, setIsLimit] = useState(false);

  const formik = useFormik({
    initialValues: {
      username: "", // nurbek
      password: "", // astana1998
    },
    onSubmit: async (values) => {
      if (isLimit) {
        setIsLimit(false);
      }

      dispatch(login(values));

    },
    validationSchema: loginSchema,
  });

  const { values, handleChange, handleSubmit } = formik;
  const { username, password } = values;
  const {error} = useTypedSelector(state=>state.auth)
  // console.log(error)

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  return (
    <GridBlock>
      <Stack sx={{ width: "clamp(250px, 100%, 600px)" }}>
        <Headline>Вход</Headline>
        <form onSubmit={handleSubmit}>
          <>
            <InputBox>
              <InputUpperLabel>Имя пользователя</InputUpperLabel>
              <StyledNewInput
                ref={inputRef}
                name="username"
                value={username}
                required
                onChange={handleChange}
              />
              {/*{errors.username && (*/}
              {/*  <InputHelperText>{errors.username}</InputHelperText>*/}
              {/*)}*/}
            </InputBox>
            <InputBox>
              <InputUpperLabel>Пароль</InputUpperLabel>
              <StyledNewInput
                id="my-input"
                aria-describedby="my-helper-text"
                name="password"
                type="password"
                value={password}
                onChange={handleChange}
                placeholder="Введите пароль"
              />
              {/*{errors.password && (*/}
              {/*  <InputHelperText>{errors.password}</InputHelperText>*/}
              {/*)}*/}
            </InputBox>
            {/*<FormCheckBox>*/}
            {/*  <FormGroup>*/}
            {/*    <StyledCheckBox />*/}
            {/*  </FormGroup>*/}
            {/*</FormCheckBox>*/}
            <Box sx={{display:"flex", alignItems:"center",}}>
              <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  sx={{minWidth:"150px", minHeight:"50px", mt:"20px", fontSize:"20px"}}
              >
                Войти
              </Button>
            </Box>

            {error&&<div>Произошла ошибка, пожалуйста, проверьте свои данные!</div>}
          </>
        </form>
      </Stack>
    </GridBlock>
  );
};

export default LoginForm;
